<template>
    <div>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
        <div class="row mb-2">
            <div class="col-12 col-md-12 col-lg-8">
                <h1 class="text-white pt-3 px-3">หน้าจัดการลูกค้า</h1>
                <p
                    class="text-white pb-0 px-3"
                >เพิ่มลูกค้า และแสดงตารางรายละเอียดลูกค้าทั้งหมดที่มีอยู่ภายในสาขา</p>
            </div>
            <div class="col-12 col-md-12 col-lg-4 align-self-center text-right">
                <h1 class="display-3 text-white">
                    <small>จำนวนลูกค้าที่ลงทะเบียน :</small>
                    {{totalItem}}
                    <small>คน</small>
                </h1>
                <router-link :to="`/registermember`" target="_blank">
                    <button class="btn btn-xl btn-primary px-4" >เพิ่มลูกค้า</button>
                </router-link>
            </div>
      </div>
    </base-header>
    <div class="text-center" v-if="busy">
        <BlockUI>
            <div class="loader"></div>
        </BlockUI>
    </div>
    <div class="container-fluid mt--7 mb-5">
        <div class="row">
            <div class="col">
                <div class="card shadow">
                    <div class="card-header bg-transparent">
                        <div class="row justify-content-between">
                            <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                                <b-form-group class="mb-0" >
                                    <div class="row">
                                        <div class="col-6 col-md-4 col-lg-5">
                                            <input
                                                type="text"
                                                placeholder="ชื่อ"
                                                class="form-control"
                                                v-model="search.name"
                                            />
                                        </div>
                                        <div class="col-6 col-md-4 col-lg-5 mb-3">
                                            <input
                                                type="text"
                                                placeholder="เบอร์โทรศัพท์"
                                                class="form-control"
                                                v-model="search.tel"
                                            />
                                        </div>
                                        <div class="col-12 col-md-3 col-lg-2">
                                            <button class="btn btn-info btn-sm-res" @click="getMemberShop()">
                                            <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </b-form-group>
                                <hr class="d-md-none d-lg-none" />
                            </div>
                            <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                                <hr class="d-block d-md-none d-lg-none mb-0" />
                            </div>
                        </div>
                    </div>
                    <!-- table -->
                    <div id="tablePrint">
                        <b-table
                            show-empty
                            responsive
                            :items="memberShop"
                            :fields="fields"
                            :per-page="search.perPage"
                            class="scroll-bar-pop text-center"
                            empty-text="ไม่มีข้อมูลสมาชิก"
                            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                        >
                            <template slot="index" slot-scope="data">{{ getOverAllIndex( data.index ) }}</template>
                            <template slot="manage" slot-scope="data">
                                <router-link :to="`/reportcod/${data.item.mem_id}`">
                                    <button class="btn btn-sm btn-info px-3">
                                        <i class="fas fa-list"></i> ดูรายการ COD
                                    </button>
                                </router-link>
                            </template>
                        </b-table>
                        <div class="mt-3">
                            <b-pagination 
                                :total-rows="totalItem"
                                :current-page="search.page"
                                :per-page="search.perPage"
                                :value="search.page" 
                                @input="changePage"
                                align="right">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div> 
</template>
<script>
const API_URL = process.env.VUE_APP_API;
import validatePop from "../plugins/validatePop.js"
export default {
    name:"membershop",
    data(){
        return {
            busy: false,
            memberShop: [],
            search: {
                page: 1,
                perPage: 20,
                name: "",
                tel: ""
            },
            totalItem: 0,
        }
    },
    mounted(){
        this.getMemberShop()
    },
    methods:{
        getMemberShop() {
            this.busy = true
            this.$http
                .post(API_URL + "/member/shop", {
                   ...this.search
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        this.handleLoader();
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    this.handleLoader();
                    this.memberShop = res.data.data.data;
                    this.totalItem = res.data.data.totalItem;
                    
                });
        },
        handleLoader(){
            this.busy = !this.busy
        },
        changePage(i){
            if (this.search.page == i) return;
            this.search.page = i
            this.getMemberShop()
        },
        getOverAllIndex(index){
            return ( this.search.page * 20 ) - 20 + index + 1
        },
        showSuccessModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "SUCCESS",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "ตกลง",
            contentClass: "modal-success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "ERROR",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: OkmsgTitle,
            contentClass: "modal-errors",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
    },
    computed:{
        fields(){ 
            let fields = [
                { key: "index", label: "ลำดับ", sortable: true },
                { key: "name", label: "ชื่อลูกค้า", sortable: true },
                { key: "tel", label: "เบอร์โทรศัพท์", sortable: true },
                { key: "email", label: "อีเมล์", sortable: true },
                { key: "tax_id", label: "เลขบัตรประชาชน", sortable: true },
                { key: "manage", label: "จัดการ" }
            ]
            return fields
        }
    }
}
</script>
<style lang="scss">
  .report{
    color: #212529;
    font-size: 1.1rem;
    width: 6rem;
  }
</style>